import { ProviderType, ReportingCenter, TrackingEvent } from '@/reporting';
import { getStoreInstance } from '@/store';
import { IS_CA } from '@/utils/constants';
import { TrackEventFunction } from 'index';
import { useCallback } from 'react';

const CA_LENS_FLOW_EVENT_PREFIXES = [
  'PrescriptionTypePage_',
  'PrescriptionEnterPage_',
  'LensTypePage_',
  'LensIndexPage_',
  'CoatingPage_',
  'ViewAreaPage_',
];

function isCaLensFlowEvent(event: TrackingEvent): boolean {
  const eventName = event.eventName ?? '';
  if (
    eventName === 'ProductDetailsPageBtn_Click' ||
    eventName === 'ProductDetailsPage_View' ||
    eventName === 'AddToCart_Result'
  ) {
    return true;
  }

  if (eventName === 'PopUp_Exp' || eventName === 'PopUp_Click') {
    return event.properties?.popup_type === '选择加购方式弹窗';
  }

  return CA_LENS_FLOW_EVENT_PREFIXES.some((prefix) => eventName.startsWith(prefix));
}

export function addCaLensFlowExperimentProperty(event: TrackingEvent): TrackingEvent {
  if (
    !IS_CA ||
    !isCaLensFlowEvent(event) ||
    getStoreInstance()?.getState().caLensFlowAssignment.variant !== 'experiment'
  ) {
    return event;
  }

  return {
    ...event,
    properties: {
      ...event.properties,
      pub_env_name: 'ABtest',
    },
  };
}

export function useReporting() {
  /**
   * 追踪事件 - 支持两种调用模式：
   *
   * 模式1 - 直接事件追踪 (保持向后兼容)：
   * trackEvent(event, specificProviders, adaptionData?)
   *
   * 模式2 - 适配器模式：
   * trackEvent(event?, specificProviders, adaptionData, adapterType)
   */
  const trackEvent: TrackEventFunction = useCallback(
    (
      event: TrackingEvent | undefined,
      specificProviders: ProviderType[],
      adaptionData?: unknown,
      adapterType?: string,
    ) => {
      // 检查是否在客户端环境中
      if (typeof window === 'undefined') {
        // 服务端环境，直接返回，不执行追踪
        return;
      }

      const center = ReportingCenter.getInstance();
      center.track(
        event ? addCaLensFlowExperimentProperty(event) : event,
        specificProviders,
        adaptionData,
        adapterType,
      );
    },
    [],
  );

  return { trackEvent };
}
